<template>
	<div class="">
		<!-- <div class="col-12 my-2">
			<label class="text-muted">Event*</label>
			<select class="form-control">
				<option value="confId">{{confName}}</option>
			</select>
		</div> -->
		<div class="col-12 my-2 mb-4 small" v-if="register.added">
			<p>Reference ID: {{ activeId }}
			<br/>Date: {{ (register.added.toDate()).toString().slice(0,23) }}</p>
		</div>
		<div class="col-12 my-2">
			<label class="text-muted">Conference ticket*</label>
			<select class="form-control" v-model="confticket">
				<option v-show="ticket.data.ispublic" v-for="ticket in confTickets" :key="ticket.id" :value="{id: ticket.id, name: ticket.data.name, price: ticket.data.price} ">{{ticket.data.name}}<!--  {{ticket.data.price > 0 ? ` - ${ticket.data.price.toLocaleString("en-US", {style:"currency", currency:"USD"})}` : ""}} --></option>
			</select>
		</div>
		<div class="col-12 my-2">
			<label class="text-muted">First name*</label>
			<input type="text" class="form-control"  v-model="register.fname">
		</div>
		<div class="col-12 my-2">
			<label class="text-muted">Last name*</label>
			<input type="text" class="form-control" v-model="register.lname" >
		</div>
		<div class="col-12 my-2">
			<label class="text-muted">Email address*</label>
			<input type="text" class="form-control" readonly v-model="register.email" >
		</div>
		<div class="col-12 my-2">
			<label class="text-muted">Telephone contact*</label>
			<input type="text" class="form-control" v-model="register.phone" >
		</div>
		<div class="col-12 my-2">
			<label class="text-muted">Gender*</label>
			<select class="form-control" readonly v-model="register.gender">
				<option>FEMALE</option> 
				<option>MALE</option> 
				<option>NON-BINARY</option> 
			</select>
		</div>
		<div class="col-12 my-2">
			<label class="text-muted">Country*</label>
			<select class="form-control" readonly v-model="register.country">
				<option value="ANGUILLA">ANGUILLA</option>
				<option value="ANTIGUA AND BARBUDA">ANTIGUA AND BARBUDA</option>
				<option value="ARUBA">ARUBA</option>
				<option value="BARBADOS">BARBADOS</option>
				<option value="BONAIRE">BONAIRE</option>
				<option value="CURACAO">CURAÇAO</option>
				<option value="DOMNICA">DOMINICA</option>
				<option value="FRENCH GUIANA">FRENCH GUIANA</option>
				<option value="GRENADA">GRENADA</option>
				<option value="GUADELOUPE">GUADELOUPE</option>
				<option value="GUYANA">GUYANA</option>
				<option value="JAMAICA">JAMAICA</option>
				<option value="MARTINIQUE">MARTINIQUE</option>
				<option value="MONTSERRAT">MONTSERRAT</option>
				<option value="SAINT KITTS AND NEVIS">SAINT KITTS AND NEVIS</option>
				<option value="SAINT LUCIA">SAINT LUCIA</option>
				<option value="SAINT VINCENT AND THE GRENADINES">SAINT VINCENT AND THE GRENADINES</option>
				<option value="SURINAME">SURINAME</option>
				<option value="TRINIDAD AND TOBAGO">TRINIDAD AND TOBAGO</option>
				<option disabled>------</option>
				<option>OTHER</option>
			</select>
		</div>
		
		<div class="col-12 my-2">
			<label class="text-muted">Club*</label>
			<select class="form-control" readonly v-model="register.club">
				<option>Other</option>
				<option>Not Aplicable</option>
				<option disabled>--------------</option>
				<option disabled>Rotary Clubs</option>
				<option disabled>--------------</option>
				<option  data-type="Rotarian">RC Antigua</option>
				<option  data-type="Rotarian">RC Antigua Sundown</option>
				<option  data-type="Rotarian">RC Arima</option>
				<option  data-type="Rotarian">RC Aruba</option>
				<option  data-type="Rotarian">RC Barbados</option>
				<option  data-type="Rotarian">RC Barbados South</option>
				<option  data-type="Rotarian">RC Barbados West</option>
				<option  data-type="Rotarian">RC Basse Terre</option>
				<option  data-type="Rotarian">RC Basse Terre Fort Saint Charles</option>
				<option  data-type="Rotarian">RC Bequia</option>
				<option  data-type="Rotarian">RC Bonaire</option>
				<option  data-type="Rotarian">RC Cayenne</option>
				<option  data-type="Rotarian">RC Cayenne-Est</option>
				<option  data-type="Rotarian">RC Central Port of Spain</option>
				<option  data-type="Rotarian">RC Chaguanas</option>
				<option  data-type="Rotarian">RC Coeur Caraibes (Lamentin)</option>
				<option  data-type="Rotarian">RC Corriverton</option>
				<option  data-type="Rotarian">RC Curacao</option>
				<option  data-type="Rotarian">RC Demerara</option>
				<option  data-type="Rotarian">RC Diego Martin</option>
				<option  data-type="Rotarian">RC Dominica</option>
				<option  data-type="Rotarian">RC Felicity-Charlieville</option>
				<option  data-type="Rotarian">RC Fort-de-France</option>
				<option  data-type="Rotarian">RC Fort-de-France Ouest</option>
				<option  data-type="Rotarian">RC Fort-de-France Sud</option>
				<option  data-type="Rotarian">RC Francois</option>
				<option  data-type="Rotarian">RC Garden City (Guyana)</option>
				<option  data-type="Rotarian">RC Georgetown</option>
				<option  data-type="Rotarian">RC Georgetown Central</option>
				<option  data-type="Rotarian">RC Grande Terre Pointe Des Chateaux</option>
				<option  data-type="Rotarian">RC Grenada</option>
				<option  data-type="Rotarian">RC Grenada East</option>
				<option  data-type="Rotarian">RC Gros Islet</option>
				<option  data-type="Rotarian">RC Kourou</option>
				<option  data-type="Rotarian">RC Lamentin</option>
				<option  data-type="Rotarian">RC Liamuiga</option>
				<option  data-type="Rotarian">RC Maracas-St. Joseph</option>
				<option  data-type="Rotarian">RC Maraval</option>
				<option  data-type="Rotarian">RC Marie-Galante</option>
				<option  data-type="Rotarian">RC Montserrat</option>
				<option  data-type="Rotarian">RC New Amsterdam</option>
				<option  data-type="Rotarian">RC Paramaribo</option>
				<option  data-type="Rotarian">RC Paramaribo Central</option>
				<option  data-type="Rotarian">RC Paramaribo Quota</option>
				<option  data-type="Rotarian">RC Paramaribo Residence</option>
				<option  data-type="Rotarian">RC Penal</option>
				<option  data-type="Rotarian">RC Piarco</option>
				<option  data-type="Rotarian">RC Point Fortin</option>
				<option  data-type="Rotarian">RC Pointe-A-Pierre</option>
				<option  data-type="Rotarian">RC Pointe-a-Pitre Doyen</option>
				<option  data-type="Rotarian">RC Pointe-a-Pitre Est</option>
				<option  data-type="Rotarian">RC Pointe-a-Pitre Fleur d"Epee</option>
				<option  data-type="Rotarian">RC Pointe-a-Pitre Jarry</option>
				<option  data-type="Rotarian">RC Port of Spain</option>
				<option  data-type="Rotarian">RC Port of Spain West</option>
				<option  data-type="Rotarian">RC Portsmouth</option>
				<option  data-type="Rotarian">RC Princes Town</option>
				<option  data-type="Rotarian">RC Remire Montjoly</option>
				<option  data-type="Rotarian">RC Saint Pierre</option>
				<option  data-type="Rotarian">RC Saint-Laurent Mana Ouest Guyanais</option>
				<option  data-type="Rotarian">RC San Fernando</option>
				<option  data-type="Rotarian">RC San Fernando-South</option>
				<option  data-type="Rotarian">RC San Juan</option>
				<option  data-type="Rotarian">RC Sangre Grande</option>
				<option  data-type="Rotarian">RC Schoelcher</option>
				<option  data-type="Rotarian">RC Southwest-Tobago</option>
				<option  data-type="Rotarian">RC St. Augustine</option>
				<option  data-type="Rotarian">RC St. Augustine West</option>
				<option  data-type="Rotarian">RC St. Kitts</option>
				<option  data-type="Rotarian">RC St. Lucia</option>
				<option  data-type="Rotarian">RC St. Vincent</option>
				<option  data-type="Rotarian">RC St. Vincent South</option>
				<option  data-type="Rotarian">RC Stabroek-Georgetown</option>
				<option  data-type="Rotarian">RC Tobago</option>
				<option  data-type="Rotarian">RC Willemstad</option>        
				<option disabled>--------------</option>
				<option disabled>Rotaract Clubs</option>
				<option disabled>--------------</option>
				<option data-type="Rotaractor">RTC Antigua</option>
				<option data-type="Rotaractor">RTC Arima</option>
				<option data-type="Rotaractor">RTC Arima West</option>
				<option data-type="Rotaractor">RTC Aruba</option>
				<option data-type="Rotaractor">RTC Aruba</option>
				<option data-type="Rotaractor">RTC Barbados</option>
				<option data-type="Rotaractor">RTC Barbados</option>
				<option data-type="Rotaractor">RTC Barbados West</option>
				<option data-type="Rotaractor">RTC Cayenne</option>
				<option data-type="Rotaractor">RTC Central Port of Spain</option>
				<option data-type="Rotaractor">RTC Chaguanas</option>
				<option data-type="Rotaractor">RTC Curacao</option>
				<option data-type="Rotaractor">RTC F.R.E.S.H.</option>
				<option data-type="Rotaractor">RTC Felicity-Charlieville</option>
				<option data-type="Rotaractor">RTC Fort-de-France</option>
				<option data-type="Rotaractor">RTC Genesis of Suriname</option>
				<option data-type="Rotaractor">RTC Georgetown</option>
				<option data-type="Rotaractor">RTC Georgetown Central</option>
				<option data-type="Rotaractor">RTC Grenada</option>
				<option data-type="Rotaractor">RTC Grenada-East</option>
				<option data-type="Rotaractor">RTC Gros Islet</option>
				<option data-type="Rotaractor">RTC Gros Islet</option>
				<option data-type="Rotaractor">RTC Ile de Cayenne</option>
				<option data-type="Rotaractor">RTC Kingstown</option>
				<option data-type="Rotaractor">RTC Kourou</option>
				<option data-type="Rotaractor">RTC L.E.P. Francois</option>
				<option data-type="Rotaractor">RTC Lamentin</option>
				<option data-type="Rotaractor">RTC Linden</option>
				<option data-type="Rotaractor">RTC Maraval</option>
				<option data-type="Rotaractor">RTC Marie-Galante</option>
				<option data-type="Rotaractor">RTC Montserrat</option>
				<option data-type="Rotaractor">RTC Mount Hope</option>
				<option data-type="Rotaractor">RTC Nevis</option>
				<option data-type="Rotaractor">RTC New Amsterdam</option>
				<option data-type="Rotaractor">RTC Paramaribo</option>
				<option data-type="Rotaractor">RTC Penal</option>
				<option data-type="Rotaractor">RTC Piarco</option>
				<option data-type="Rotaractor">RTC Piarco (U.W.I)</option>
				<option data-type="Rotaractor">RTC Point Fortin</option>
				<option data-type="Rotaractor">RTC Pointe-a-Pitre</option>
				<option data-type="Rotaractor">RTC Pointe-a-Pitre</option>
				<option data-type="Rotaractor">RTC Ponte a Pierre</option>
				<option data-type="Rotaractor">RTC Port Of Spain</option>
				<option data-type="Rotaractor">RTC Port of Spain West</option>
				<option data-type="Rotaractor">RTC Roseau</option>
				<option data-type="Rotaractor">RTC Saint Pierre</option>
				<option data-type="Rotaractor">RTC Saint Pierre</option>
				<option data-type="Rotaractor">RTC San Fernando</option>
				<option data-type="Rotaractor">RTC San Fernando</option>
				<option data-type="Rotaractor">RTC San Fernando South</option>
				<option data-type="Rotaractor">RTC Sangre Grande</option>
				<option data-type="Rotaractor">RTC South Barbados</option>
				<option data-type="Rotaractor">RTC South St. Lucia</option>
				<option data-type="Rotaractor">RTC Southwest Tobago</option>
				<option data-type="Rotaractor">RTC St. Augustine</option>
				<option data-type="Rotaractor">RTC St. Augustine West</option>
				<option data-type="Rotaractor">RTC St. Kitts</option>
				<option data-type="Rotaractor">RTC St. Lucia</option>
				<option data-type="Rotaractor">RTC Stabroek</option>
				<option data-type="Rotaractor">RTC University of Guyana</option>
				<option data-type="Rotaractor">RTC UWI Cave Hill Barbados</option>
				<option data-type="Rotaractor">RTC UWI Cavehill</option>
			</select>
		</div>
		<div class="col-12 my-2">
			<label class="text-muted">Incoming club position ({{confInfo.confincomingyear}})*</label>
			<select class="form-control" v-model="register.club_role">
				<option>OTHER</option> 
				<option>NOT APPLICABLE</option> 
				<option disabled>------</option>
				<option>CLUB PRESIDENT</option>
				<option>CLUB SECRETARY</option>
				<option>CLUB PRESIDENT-ELECT</option>
				<option>CLUB SECRETARY-ELECT</option>
				<option>CLUB DIRECTOR/OFFICER</option>
				<option>ASSISTANT GOVERNOR</option>
				<option>ASSISTANT GOVERNOR-ELECT</option>
				<option>ASSISTANT DISTRICT ROTARACT REPRESENTATIVE</option>
				<option>ASSISTANT DISTRICT ROTARACT REPRESENTATIVE-ELECT</option>
				<option>DISTRICT OFFICER</option>
				<option>DISTRICT OFFICER ELECT</option>   
			</select>
		</div>
		<div class="col-12" v-show="confInfo.confvirtual===false">
			<div class="row">
				<div class="col-12 my-2">
					<label class="text-muted">Shirt/Polo size*</label>
					<select class="form-control" v-model="register.tshirt">
						<option >X-SMALL</option>
						<option >SMALL</option>
						<option >MEDIUM</option>
						<option >LARGE</option>
						<option >X-LARGE</option>
						<option >2X-LARGE</option>
						<option >3X-LARGE</option>
					</select>
				</div>
				<div class="col-12 my-2">
					<label class="text-muted">Conference booklet*</label>
					<select class="form-control" v-model="register.booklet">
						<option >DIGITAL</option>
						<option >HARDCOPY</option>
						<option >NONE</option>
					</select>
				</div>
				<div class="col-12 my-2">
					<label class="text-muted">Dietary requirements*</label>
					<select class="form-control" v-model="register.dietsubject">
						<option>NONE</option>
						<option>ALLERGIES</option>
						<option>DIABETIC</option>
						<option>LACTOSE INTOLERANT</option>
						<option>NO PORK</option>
						<option>NO RED MEAT</option>
						<option>NO SEAFOOD</option>
						<option>NO SHELLFISH</option>
						<option>VEGETARIAN</option>
						<option>OTHER</option>
						
					</select>
					<textarea  rows="3" class="form-control my-2" placeholder="Please provide details" v-model="register.dietdetails" v-show="register.dietsubject && register.dietsubject=='OTHER'"/>
				</div>
				<div class="col-12 my-2">
					<label class="text-muted">Special requirements*</label>
					<select class="form-control" v-model="register.reqsubject">
						<option >NONE</option>
						<option>ASSISTED LISTENING DEVICES</option>
						<option>BRAILLE MATERIALS</option>
						<option>WHEELCHAIR</option>
						<option>OTHER</option>
					</select>
					<textarea rows="3" class="form-control my-2" placeholder="Please provide details" v-model="register.reqdetails" v-show="register.reqsubject && register.reqsubject=='OTHER'"/>
				</div>
				<div class="col-12 my-2">
					<hr size="1" />
					<h5>Emergency Contact Information</h5>
					<label class="text-muted">Emergency contact full name*</label>
					<input type="text" class="form-control" v-model="register.ename" />
				</div>
				<div class="col-12 my-2">
					<label class="text-muted">Emergency contact phone number*</label>
					<input type="text" class="form-control" v-model="register.ephone" />
				</div>
				<div class="col-12 my-2">
					<label class="text-muted">Relation to emergency contact*</label>
					<select class="form-control" v-model="register.erelation">
						<option>SPOUSE</option>
						<option>PARENT</option>
						<option>SIBLING</option>
						<option>CHILD</option>
						<option>OTHER</option>
					</select>
				</div>
				<div class="col-12 my-2">
					<hr/>
					<label class="text-muted">Status*</label>
					<select class="form-control" v-model="register.status">
						<option>PAID</option>
						<option>REGISTERED</option>
						<option>CANCELLED</option>
						<option>REFUNDED</option>
					</select>
				</div>
				<div class="col-12 my-5">
					<button class="btn btn-block btn-primary btn-lg" :disabled="!isFormValid||isBusy" @click="btnContinueClick">
						<span v-show="!isBusy">Save</span>
						<div class="spinner-border text-light" role="status" v-show="isBusy">
							<span class="sr-only">Loading...</span>
						</div>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

const fb = require("../firebaseConfig")

export default {
	name: "RegistrationForm",
	components: {

	},
	props:["activeData", "activeId"],
    computed:{
		confId(){
            return this.$store.state.confId
        },
        confName(){
            return this.$store.state.confName
        },
        confInfo(){
            return this.$store.state.confInfo
        },
        confList(){
			return this.$store.state.confList
        },
        confData(){
            return Array.isArray(this.confList) && this.confList.length > 0 ? this.confList.filter((c) => c.id === this.confId )[0].data : {}
        },
        filterTickets(){
            if(this.confTickets === "" && this.confPaymentStatus == "") return this.registrations;
			if(this.confTickets !== "" && this.confPaymentStatus !== ""){
				return this.registrations.filter((r) => r.data.confticketid === this.confTickets && r.data.status === this.confPaymentStatus);
			}else{
				if(this.confTickets !== "") return this.registrations.filter((r) => r.data.confticketid === this.confTickets);
				if(this.confPaymentStatus !== "") return this.registrations.filter((r) => r.data.status === this.confPaymentStatus);
			}

			return this.registrations;
        },
        userProfile(){
            console.log(this.$store.state.userProfileDoc)
            return this.$store.state.userProfile
        },
		isFormValid(){
            if(!this.confticket) return false
			if(!this.register.fname) return false
			if(!this.register.lname) return false
			if(!this.register.email) return false
			if(!this.register.phone) return false
			if(!this.register.gender) return false
			if(!this.register.country) return false
			if(!this.register.club) return false
			if(!this.register.club_role) return false

            if(this.confInfo.confvirtual===false){
                if(!this.register.tshirt) return false
                if(!this.register.booklet) return false
                if(!this.register.ename) return false
                if(!this.register.ephone) return false
                if(!this.register.erelation) return false
                if(!this.register.dietsubject) return false
                if(!this.register.reqsubject) return false
                if(this.register.dietsubject && this.register.dietsubject=="OTHER" && !this.register.dietdetails) return false
                if(this.register.reqsubject && this.register.reqsubject=="OTHER" && !this.register.reqdetails) return false 
            }
            
            return true
        }
    },
    data(){
        return{
			isBusy: false,
			register:this.activeData,
			confticket:{
				id: this.activeData.confticketid, 
				name: this.activeData.confticket, 
				price: this.activeData.confticketprice
			},
			confTickets:[],
        }
    },
    methods:{
		btnContinueClick(){
			this.isBusy = true;
			const orderId = this.activeId;
			this.register.confticket = this.confticket.name
            this.register.confticketid = this.confticket.id
            this.register.confticketprice = this.confticket.price
			fb.ordersCollection.doc(String(orderId)).update(this.register).then(()=>{
                fb.adminEmailCollection.add({
                    to:this.register.email,
                    message:{
                        subject: `${this.register.fname} - your registration was updated.`,
                        html:`<p>${this.register.fname},</p>
                        <p>Your conference registration has been updated. Please login to your account to view the update.</p>
                        <p>&nbsp;</p>
                        <p>Name - ${this.register.fname} ${this.register.lname}</p>
						<p>Email - ${this.register.email}</p>
						<p>Phone - ${this.register.phone}</p>
						<p>Ticket - ${this.confticket.name}</p>
                        <p>Incoming Club Role - ${this.register.club_role}</p>
						<p>T-shirt - ${this.register.tshirt}</p>
						<p>Dietary Requirements - ${this.register.dietsubject}</p>
						<p>Special Requirements - ${this.register.reqsubject}</p>
                        <p>-------</p>
						<p>Emergency Contact Name - ${this.register.ename}</p>
						<p>Emergency Contact Phone - ${this.register.ephone}</p>
						<p>Emergency Contact Relation - ${this.register.erelation}</p>
                        <p>&nbsp;</p>
						<p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p><hr/></p>
                        <p style="font-size:10px;">${this.confInfo.confhost}</p>`,
                    },
                }).then(()=>{
                })
                this.showForm = false
                window.scrollTo(0,0)
				Vue.$toast.success("User registration was updated.", {position:"top"})
				this.isBusy = false;
            }).catch((error) => {
                console.error("Error writing document: ", error);
				this.isBusy = false;
            })
		},
    },
    mounted(){
		const confId = this.$route.params.id
        this.$store.dispatch("fetchConfProfile", confId)
        fb.confticketsCollection.where("eventid", "==", confId).onSnapshot((querySnapshot)=>{
            let confTickets = []
            querySnapshot.forEach((doc)=>{
                confTickets = [...confTickets, {id: doc.id, data: doc.data()}]
            })
            this.confTickets = confTickets
        })
    }
}
</script>
